<template>
  <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="700px" persistent>
    <v-card>
      <v-card-title class="text-h6">
        {{ title }}
        <v-spacer></v-spacer>
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field v-model="localFilters.date_from" density="comfortable" type="date" label="Fecha Desde"></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field v-model="localFilters.date_to" density="comfortable" type="date" label="Fecha Hasta"></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-combobox
                v-model="localFilters.almacen"
                density="comfortable"
                name="almacen"
                item-title="name"
                item-value="id"
                :items="almacenes"
                label="Almacén"
                autocomplete="off"
                clearable
              ></v-combobox>
            </v-col>

            <v-col cols="12">
              <v-combobox
                v-model="localFilters.client"
                density="comfortable"
                name="cliente"
                item-title="name"
                item-value="id"
                :items="clients"
                label="Cliente"
                autocomplete="off"
                clearable
              ></v-combobox>
            </v-col>

            <v-col cols="12">
              <v-combobox
                v-model="localFilters.canal_venta"
                density="comfortable"
                name="canal_venta"
                item-title="name"
                item-value="id"
                :items="canalesVenta"
                label="Canal de Venta"
                autocomplete="off"
                clearable
              ></v-combobox>
            </v-col>

            <v-col cols="12">
              <v-text-field v-model="localFilters.wave_code" density="comfortable" label="Número de Ola"></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field v-model="localFilters.code" density="comfortable" label="Número de Envío"></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="close"> Cancelar </v-btn>
        <v-btn color="primary" @click="apply"> Aplicar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ModalFilterPicking",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Filtros",
    },
    filters: {
      type: Object,
      required: true,
    },
    almacenes: {
      type: Array,
      default: () => [],
    },
    clients: {
      type: Array,
      default: () => [],
    },
    canalesVenta: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localFilters: {
        date_from: null,
        date_to: null,
        almacen: null,
        client: null,
        canal_venta: null,
        wave_code: "",
        code: "",
      },
    };
  },
  watch: {
    modelValue(val) {
      if (val) {
        this.localFilters = {
          date_from: this.filters.date_from,
          date_to: this.filters.date_to,
          almacen: this.filters.almacen,
          client: this.filters.client,
          canal_venta: this.filters.canal_venta,
          wave_code: this.filters.wave_code,
          code: this.filters.code,
        };
      }
    },
  },
  methods: {
    close() {
      this.$emit("update:modelValue", false);
      this.$emit("close");
    },
    apply() {
      this.$emit("update:filters", this.localFilters);
      this.$emit("apply");
    },
  },
};
</script>

<style scoped>
.v-card-title {
  background-color: #f5f5f5;
  font-weight: 500;
}
</style>
